import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20flat%20lay%20with%20premium%20fashion%20accessories%20a%20leather%20bag%20and%20folded%20clothing%20on%20a%20warm%20cream%20textured%20surface%20soft%20natural%20daylight%20from%20above%20editorial%20product%20photography%20sophisticated%20neutral%20palette%20airy%20atmosphere%20with%20ample%20center%20space&width=1800&height=600&seq=cta-main-v3-02&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-semibold text-white max-w-2xl">
          {t('cta.title')}
        </h2>
        <p className="mt-3 text-sm md:text-base text-white/70 max-w-xl">
          {t('cta.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-right-line"></i>
            {t('cta.button')}
          </a>
          <Link
            to="/oopbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white font-semibold text-sm border border-white/30 hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            {t('article.read_more')}
          </Link>
        </div>
      </div>
    </section>
  );
}